export const StepNeedErrorCode = 4071;
export const enum StepError {
  NEED_TRADE_PASSWORD = 4046,
  // NEED_BIND_CARD = 4117,
  NEED_ADDRESS = 4120,
  NEED_PHONE = 4121,
  NEED_KYC = 4122,
  NEED_TRADE_PASSWORD_BIND_CARD = 4124,
  /** @deprecated */
  NEED_REKYC = 4125,
  NEED_CARF = 4132,
}
